import { THUMBNAIL_HEIGHT } from '../consts';
import { useCyclingThumbnailFrame } from '../hooks/useCyclingThumbnailFrame';
import { ThumbnailDisplayInfo } from '../types';
import { ThumbnailFrame } from './ThumbnailFrame';
import { ThumbnailSprite } from './ThumbnailSprite';

type Props = Omit<ThumbnailDisplayInfo, 'offset' | 'animated'>;

/**
 * Bordered thumbnail that cycles through all sprite frames (including multi-row grids).
 */
export function AnimatedThumbnail({ url, metadata, targetHeight = THUMBNAIL_HEIGHT }: Props) {
  const frameIndex = useCyclingThumbnailFrame(metadata);

  return (
    <ThumbnailFrame>
      <ThumbnailSprite
        url={url}
        metadata={metadata}
        frameIndex={frameIndex}
        mode="px"
        targetHeight={targetHeight}
      />
    </ThumbnailFrame>
  );
}
